export default __webpack_public_path__ + "static/media/phone_verification.ef006a0d.png";